var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 19,
    height: 9,
    rx: 1.5,
    stroke: "#2A2D34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5H21C21.2761 7.5 21.5 7.72386 21.5 8V10C21.5 10.2761 21.2761 10.5 21 10.5H19.5V7.5Z",
    stroke: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39371 7.41145C7.98968 4.67041 14.813 -0.51344 14.2585 0.0411769C13.7594 0.540426 12.0391 3.23538 10.9439 4.98267C10.5286 5.64529 11.0069 6.5 11.7889 6.5H15.0601C15.9547 6.5 16.4021 7.57955 15.7628 8.2054C12.1961 11.6974 4.42927 19.2562 5.00851 18.291C5.54944 17.3897 8.30114 13.237 9.79325 10.9918C10.2207 10.3485 9.78911 9.48413 9.01813 9.43878L4.94477 9.19917C4.01944 9.14474 3.65652 7.97337 4.39371 7.41145Z",
    fill: "#00A651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.14d7c1282b63c5c82dd40dd2536aed3c.svg";
export { ForwardRef as ReactComponent };